import { nullable } from '@abb-procure/api';
import * as t from 'io-ts';
import { GuidNameCode } from './guid-name-code.type';

const LocalDivisionLookup = t.intersection(
  [
    GuidNameCode,
    t.type({
      displayedName: nullable(t.string),
      productGroups: nullable(t.array(GuidNameCode)),
    }),
  ],
  'LocalDivisionLookup',
);

type LocalDivisionLookup = t.TypeOf<typeof LocalDivisionLookup>;
export { LocalDivisionLookup };
